import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import SweetAlert from 'sweetalert-react';

import * as Utils from '../../../utils/utils';
import * as Orders from '../../../utils/ordersHelper';
import * as OrdersActions from '../../../actions/ordersActions';
import { getOrder as fetchOrderDetails } from '../../../services/orders';

class OrderListView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeGroup: 'current',
      showAlert: false,
      orderDetails: {},
      swalParams: {
        title: ""
      }
    }

    this.renderOrders = this.renderOrders.bind(this);
    this.getOrderGroup = this.getOrderGroup.bind(this);
    this.exploreOrder = this.exploreOrder.bind(this);
    this.formatOrderNumber = this.formatOrderNumber.bind(this);
    this.getItemCount = this.getItemCount.bind(this);
    this.getOrderProducts = this.getOrderProducts.bind(this);
    this.prefetchOrderDetails = this.prefetchOrderDetails.bind(this);
  }

  componentDidMount() {

    this._isMounted = true;

    this.props.dispatch(OrdersActions.getOrders(response => {
      if (!response.status) {
        this.setState({
          showAlert: true,
          swalParams: {
            title: "Failed to load order list, please try again later!",
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.orders !== this.props.orders || prevState.activeGroup !== this.state.activeGroup) {
      const orderGroup = this.getOrderGroup(this.props.orders);
      const sortedOrders = orderGroup ? Orders.sortOrdersByCreatedAt(orderGroup, 'desc') : [];
      this.prefetchOrderDetails(sortedOrders);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {

    console.log("ORDER_LIST_VIEW_PROPS", this.props);
    const { activeGroup, showAlert, swalParams } = this.state;
    return (
      <div className="page order-list-view">
        <div className="tabs-container">
          <div className={`tab ${activeGroup === 'upcoming'
            ? 'active'
            : ''}`} onClick={() => this.setState({ activeGroup: 'upcoming' })}>Upcoming Orders</div>
          <div className={`tab ${activeGroup === 'current'
            ? 'active'
            : ''}`} onClick={() => this.setState({ activeGroup: 'current' })}>Current Orders</div>
          <div className={`tab ${activeGroup === 'past'
            ? 'active'
            : ''}`} onClick={() => this.setState({ activeGroup: 'past' })}>Past Orders</div>
          <div className={`tab ${activeGroup === 'canceled'
            ? 'active'
            : ''}`} onClick={() => this.setState({ activeGroup: 'canceled' })}>Canceled Orders</div>
        </div>
        <div className="order-groups">
          {this.renderOrders()}
        </div>
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={() => this.setState({ showAlert: false })} show={showAlert} {...swalParams} onConfirm={() => this.setState({ showAlert: false })} />
      </div>
    )
  }

  renderOrders() {

    const { activeGroup } = this.state;
    let orderGroup = this.getOrderGroup();
    let sortedOrders = orderGroup ? Orders.sortOrdersByCreatedAt(orderGroup, 'desc') : [];

    console.log("SORTED_ORDERS", sortedOrders);

    return sortedOrders && sortedOrders.length > 0
      ? (
        <div className="order-list modern">
          {sortedOrders.map((order, idx) => {
            const details = this.state.orderDetails[order._id];
            const itemCount = this.getItemCount(details || order);
            const products = this.getOrderProducts(details || order);
            return (
              <div className="order-card" key={`${order.status}_order_${idx}`} onClick={() => this.exploreOrder(order)}>
                <div className="order-card__header">
                  <div className="order-card__code">{this.formatOrderNumber(order)}</div>
                  <div className={`order-card__status ${order.status ? order.status.toLowerCase() : ''}`}>{order.status}</div>
                </div>
                <div className="order-card__content">
                  <div className="order-card__meta">
                    <div className="order-card__timestamp">{Moment(order.createdAt).format('MMMM D, YYYY [at] h:mm A')}</div>
                  </div>
                  <div className="order-card__total">
                    <div className="order-card__total-amount">{order.total
                      ? `$${Number(order.total).toFixed(2)}`
                      : ''}</div>
                    <div className="order-card__items">{itemCount > 0 ? `x${itemCount}` : ''}{order.subTotal
                      ? ` $${Number(order.subTotal).toFixed(2)}`
                      : ''}</div>
                  </div>
                </div>
                <div className="order-card__products">
                  {products && products.length > 0 ? products.map((product, productIdx) => (
                    <div className="order-card__product" key={`${order._id}_product_${productIdx}`}>
                      <div className="order-card__product-info">
                        {product.image && <img className="order-card__product-image" src={product.image} alt={product.name} />}
                        <div className="order-card__product-name">{product.name || 'Product'}</div>
                      </div>
                      <div className="order-card__product-price">{product.qty ? `x${product.qty}` : ''}{product.linePrice
                        ? ` $${product.linePrice}`
                        : product.price
                          ? ` $${Number(product.price).toFixed(2)}`
                          : ''}</div>
                    </div>
                  )) : (
                    <div className="order-card__product order-card__product--placeholder">
                      <div className="order-card__product-name">Items from this order</div>
                    </div>
                  )}
                </div>
                <div className="order-card__footer">
                  <div className="order-card__location">{order.address
                    ? `Home - ${order.address.city || order.address.description || ''}`
                    : ''}</div>
                  <button
                    className="button button-primary order-card__reorder"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.exploreOrder(order);
                    }}
                  >
                    Reorder
                  </button>
                </div>
              </div>
            )
          })}
        </div>
      )
      : (
        <div className="no-content">
          <div className="title">{`No ${Utils.toTitleCase(activeGroup)} Orders`}</div>
        </div>
      );
  }

  formatOrderNumber(order) {
    if (order && order.transactionID) {
      return order.transactionID.toUpperCase();
    }
    if (order && order._id) {
      return `ORD-${order._id.slice(-8).toUpperCase()}`;
    }
    return 'Order';
  }

  getItemCount(order) {
    const quantities = order && order.qty ? order.qty : [];
    if (!quantities || !quantities.length) return 0;
    return quantities.reduce((total, qty) => total + Number(qty || 0), 0);
  }

  getOrderProducts(order) {
    if (!order || !order.products || !order.products.length) return [];

    const quantities = order.qty || [];

    return order.products.reduce((acc, product, idx) => {
      if (!product || typeof product === 'string') return acc;
      const productQty = Number(quantities[idx] || product.Qty || 1);
      const productPrice = this.getProductPrice(order, product);
      const linePrice = productPrice ? (productQty || 1) * productPrice : null;
      acc.push({
        name: product.Description || product.name || product.title || product["Item Name"] || 'Product',
        qty: productQty,
        price: productPrice,
        linePrice: linePrice !== null ? linePrice.toFixed(2) : null,
        image: product.image || product.ImageUrl || ''
      });
      return acc;
    }, []);
  }

  getProductPrice(order, product) {
    const rawPrice = product.PriceB || product.Price || product.PriceA || product.price;
    if (rawPrice) {
      return Number(rawPrice);
    }

    const priceHistory = order && order.productsPriceHistory ? order.productsPriceHistory : [];
    const priceRow = priceHistory.find((entry) => entry._id === product._id || entry._id === product.id);
    if (priceRow && priceRow.PriceB) {
      return Number(priceRow.PriceB);
    }
    return null;
  }

  getOrderGroup(ordersList) {

    const orders = Utils.toJS(ordersList || this.props.orders);
    const { activeGroup } = this.state;

    let groupedOrders = orders
      ? Orders.groupOrders(orders)
      : [];
    switch (activeGroup) {
      case 'upcoming':
        return groupedOrders.upcomingOrders;
      case 'current':
        return groupedOrders.currentOrders;
      case 'past':
        return groupedOrders.pastOrders;
      case 'canceled':
        return groupedOrders.canceledOrders;
    }
  }

  exploreOrder(order) {

    this.props.history.push(`/orders/${order._id}`)
  }

  prefetchOrderDetails(orders) {
    if (!orders || !orders.length) return;

    const { orderDetails } = this.state;
    const missingOrders = orders.filter((order) => order && order._id && !orderDetails[order._id]);

    missingOrders.forEach((order) => {
      fetchOrderDetails(order._id).then((detail) => {
        if (!this._isMounted) return;
        this.setState((prevState) => ({
          orderDetails: {
            ...prevState.orderDetails,
            [order._id]: detail
          }
        }));
      }).catch((err) => {
        console.log('order detail fetch failed', err);
      });
    });
  }
}


export default connect((state) => {
  return {
    orders: state.getIn(['orders', 'orders'])
  };
})(OrderListView)



// WEBPACK FOOTER //
// ./src/containers/settings/orders/OrderListView.js